module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hendschiken-a0c9d2cf3f8c83b81d84d154093abb1c.svg";